import { call, put, takeLatest } from 'redux-saga/effects';

import { RelatedProperty } from '../../../../types';
import { setStatus } from '../../../slices/contactForm';
import {
  loadMultipleLeadsModal,
  openMultipleLeadsModal
} from '../../../slices/multipleLeads';
import fetchRelatedProperties from '../fetchers/fetchRelatedProperties';

export function* watchLoadMultipleLeadsModalWorker(
  action: ReturnType<typeof loadMultipleLeadsModal>
) {
  try {
    const properties: Array<RelatedProperty> = yield call(
      fetchRelatedProperties,
      action.payload
    );

    if (properties.length > 0) {
      yield put(openMultipleLeadsModal(properties));
    } else {
      yield put(setStatus('success'));
    }
  } catch (e) {
    console.error(e);
    // must not fails, according to requirements.
    yield put(setStatus('success'));
  }
}

export default function* watchLoadMultipleLeadsModal() {
  yield takeLatest(loadMultipleLeadsModal, watchLoadMultipleLeadsModalWorker);
}
